<template>
  <div>
    <el-tabs v-model="tab">
      <el-tab-pane label="案例列表" name="case" />
      <el-tab-pane label="分类" name="category" />
      <el-tab-pane label="标签" name="tag" />
    </el-tabs>

    <div v-show="tab === 'case'">
      <div class="toolbar">
        <el-button type="primary" icon="el-icon-plus" @click="openCase()">新增案例</el-button>
      </div>
      <el-table :data="cases" border stripe v-loading="caseLoading">
        <el-table-column label="封面" width="90">
          <template slot-scope="{ row }">
            <img v-if="row.coverUrl" :src="row.coverUrl" class="thumb" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="160" />
        <el-table-column label="关联项目" min-width="140">
          <template slot-scope="{ row }">{{ projectLabel(row.projectId) }}</template>
        </el-table-column>
        <el-table-column label="分类" width="120">
          <template slot-scope="{ row }">{{ categoryName(row.categoryId) }}</template>
        </el-table-column>
        <el-table-column prop="budget" label="预算" width="100" />
        <el-table-column prop="sortNo" label="排序" width="80" />
        <el-table-column prop="collectCount" label="收藏" width="80" />
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="{ row }">{{ row.status === 'ON' ? '上架' : '下架' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openCase(row)">编辑</el-button>
            <el-button type="text" style="color:#f56c6c" @click="removeCase(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-show="tab === 'category'">
      <div class="toolbar">
        <el-button type="primary" icon="el-icon-plus" @click="openCategory()">新增分类</el-button>
      </div>
      <el-table :data="categories" border stripe>
        <el-table-column prop="name" label="名称" />
        <el-table-column prop="sortNo" label="排序" width="100" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{ row }">{{ row.status === 'ON' ? '启用' : '停用' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openCategory(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-show="tab === 'tag'">
      <div class="toolbar">
        <el-button type="primary" plain @click="openGroup()">新增标签组</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="openTag()">新增标签值</el-button>
        <span class="hint">建议标签组：房型、风格、面积（供案例表单下拉）</span>
      </div>
      <el-row :gutter="16">
        <el-col :span="10">
          <el-table :data="groups" border highlight-current-row @current-change="onGroupSelect">
            <el-table-column prop="name" label="标签组" />
            <el-table-column prop="sortNo" label="排序" width="70" />
            <el-table-column label="操作" width="140">
              <template slot-scope="{ row }">
                <el-button type="text" @click.stop="openGroup(row)">编辑</el-button>
                <el-button type="text" style="color:#f56c6c" @click.stop="removeGroup(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="14">
          <el-table :data="tags" border>
            <el-table-column prop="name" label="标签值" />
            <el-table-column prop="sortNo" label="排序" width="80" />
            <el-table-column label="操作" width="140">
              <template slot-scope="{ row }">
                <el-button type="text" @click="openTag(row)">编辑</el-button>
                <el-button type="text" style="color:#f56c6c" @click="removeTag(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      :title="caseForm.id ? '编辑案例' : '新增案例'"
      :visible.sync="caseVisible"
      width="880px"
      top="5vh"
      append-to-body
    >
      <el-form :model="caseForm" label-width="90px">
        <el-form-item label="标题" required>
          <el-input v-model="caseForm.title" maxlength="64" />
        </el-form-item>
        <el-form-item label="关联项目">
          <el-select
            v-model="caseForm.projectId"
            clearable
            filterable
            style="width:100%"
            placeholder="请选择要关联的项目"
            @change="onProjectChange"
          >
            <el-option
              v-for="p in projects"
              :key="p.id"
              :label="(p.name || p.customerName) + ' #' + p.id"
              :value="p.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="caseForm.projectId" label="施工动态">
          <el-switch
            v-model="caseForm.showConstruction"
            :active-value="1"
            :inactive-value="0"
          />
          <span class="hint">开启后小程序案例详情显示「施工动态」页签（项目施工图文）</span>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="caseForm.categoryId" clearable filterable style="width:100%" placeholder="请选择">
            <el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="预算">
          <el-input v-model="caseForm.budget" placeholder="如 20-30万" />
        </el-form-item>
        <el-form-item
          v-for="g in formTagGroups"
          :key="g.id"
          :label="g.name"
        >
          <el-select
            v-model="caseForm.tagPick[g.id]"
            clearable
            filterable
            style="width:100%"
            placeholder="请选择"
          >
            <el-option v-for="t in tagsOf(g.id)" :key="t.id" :label="t.name" :value="t.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="caseForm.sortNo" :min="0" />
          <span class="hint">数字越小越靠前</span>
        </el-form-item>
        <el-form-item label="封面">
          <el-upload
            action="#"
            :http-request="elUploadHttpRequest"
            :show-file-list="false"
            :on-success="onCaseCover"
            accept="image/*"
          >
            <el-button size="small" plain>上传封面</el-button>
          </el-upload>
          <div v-if="caseForm.coverUrl" class="cover-preview">
            <img :src="caseForm.coverUrl" alt="封面" />
            <el-button type="text" style="color:#f56c6c" @click="$set(caseForm, 'coverUrl', '')">清除</el-button>
          </div>
          <el-input v-model="caseForm.coverUrl" placeholder="或粘贴图片地址" style="margin-top:8px" />
        </el-form-item>
        <el-form-item label="正文">
          <rich-editor v-if="caseVisible" v-model="caseForm.body" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="caseForm.status">
            <el-radio label="ON">上架</el-radio>
            <el-radio label="OFF">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="caseVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveCase">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="categoryForm.id ? '编辑分类' : '新增分类'" :visible.sync="categoryVisible" width="420px">
      <el-form :model="categoryForm" label-width="80px">
        <el-form-item label="名称" required><el-input v-model="categoryForm.name" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="categoryForm.sortNo" :min="0" /></el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="categoryForm.status">
            <el-radio label="ON">启用</el-radio>
            <el-radio label="OFF">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="categoryVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveCategory">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="groupForm.id ? '编辑标签组' : '新增标签组'" :visible.sync="groupVisible" width="420px">
      <el-form :model="groupForm" label-width="80px">
        <el-form-item label="名称" required><el-input v-model="groupForm.name" placeholder="如 房型、风格、面积" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="groupForm.sortNo" :min="0" /></el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="groupForm.status">
            <el-radio label="ON">启用</el-radio>
            <el-radio label="OFF">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="groupVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveGroup">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="tagForm.id ? '编辑标签' : '新增标签'" :visible.sync="tagVisible" width="420px">
      <el-form :model="tagForm" label-width="80px">
        <el-form-item label="标签组" required>
          <el-select v-model="tagForm.groupId" style="width:100%">
            <el-option v-for="g in groups" :key="g.id" :label="g.name" :value="g.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" required><el-input v-model="tagForm.name" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="tagForm.sortNo" :min="0" /></el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="tagForm.status">
            <el-radio label="ON">启用</el-radio>
            <el-radio label="OFF">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="tagVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveTagRow">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listCmsCases, saveCmsCase, deleteCmsCase,
  listCaseCategories, saveCaseCategory,
  listTagGroups, saveTagGroup, deleteTagGroup,
  listTags, saveTag, deleteTag
} from '../../api/cms'
import { listProjects } from '../../api/project'
import RichEditor from '../../components/RichEditor.vue'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'CmsCase',
  components: { RichEditor },
  data() {
    return {
      tab: 'case',
      cases: [],
      categories: [],
      projects: [],
      groups: [],
      tags: [],
      allTags: [],
      currentGroupId: null,
      caseLoading: false,
      saving: false,
      caseVisible: false,
      categoryVisible: false,
      groupVisible: false,
      tagVisible: false,
      caseForm: { tagPick: {} },
      categoryForm: {},
      groupForm: {},
      tagForm: {}
    }
  },
  computed: {
    /** 表单标签组：严格按排序字段正序 */
    formTagGroups() {
      return (this.groups || [])
        .filter(g => g.status !== 'OFF')
        .slice()
        .sort((a, b) => {
          const sa = a.sortNo == null ? 0 : a.sortNo
          const sb = b.sortNo == null ? 0 : b.sortNo
          if (sa !== sb) return sa - sb
          return (a.id || 0) - (b.id || 0)
        })
    }
  },
  created() {
    this.reloadAll()
  },
  methods: {
    elUploadHttpRequest,
    async reloadAll() {
      await Promise.all([
        this.loadCases(),
        this.loadCategories(),
        this.loadProjects(),
        this.loadGroups(),
        this.loadAllTags()
      ])
    },
    categoryName(id) {
      const c = (this.categories || []).find(x => x.id === id)
      return c ? c.name : '-'
    },
    projectLabel(id) {
      if (!id) return '-'
      const p = (this.projects || []).find(x => x.id === id)
      if (!p) return '#' + id
      return (p.name || p.customerName) + ' #' + p.id
    },
    tagsOf(groupId) {
      return (this.allTags || []).filter(t => t.groupId === groupId && t.status === 'ON')
    },
    async loadCases() {
      this.caseLoading = true
      try {
        const res = await listCmsCases()
        this.cases = res.data || []
      } finally {
        this.caseLoading = false
      }
    },
    async loadCategories() {
      const res = await listCaseCategories()
      this.categories = res.data || []
    },
    async loadProjects() {
      try {
        const res = await listProjects({})
        this.projects = res.data || []
      } catch (e) {
        this.projects = []
      }
    },
    async loadGroups() {
      const res = await listTagGroups()
      this.groups = res.data || []
    },
    async loadAllTags() {
      const res = await listTags()
      this.allTags = res.data || []
      this.refreshTags()
    },
    refreshTags() {
      if (this.currentGroupId) {
        this.tags = this.tagsOf(this.currentGroupId)
      } else {
        this.tags = this.allTags
      }
    },
    onGroupSelect(row) {
      this.currentGroupId = row ? row.id : null
      this.refreshTags()
    },
    buildTagPick(tagIds) {
      const pick = {}
      const ids = tagIds || []
      ;(this.groups || []).forEach(g => {
        const hit = this.tagsOf(g.id).find(t => ids.includes(t.id))
        this.$set(pick, g.id, hit ? hit.id : null)
      })
      return pick
    },
    collectTagIds() {
      const pick = this.caseForm.tagPick || {}
      return Object.keys(pick)
        .map(k => pick[k])
        .filter(id => id != null && id !== '')
        .map(id => Number(id))
    },
    openCase(row) {
      if (row) {
        this.caseForm = {
          ...row,
          tagIds: row.tagIds || [],
          tagPick: this.buildTagPick(row.tagIds || []),
          body: row.body || '',
          showConstruction: row.showConstruction ? 1 : 0
        }
      } else {
        this.caseForm = {
          title: '',
          projectId: null,
          showConstruction: 0,
          categoryId: null,
          budget: '',
          tagIds: [],
          tagPick: this.buildTagPick([]),
          coverUrl: '',
          body: '',
          sortNo: 0,
          status: 'ON'
        }
      }
      this.caseVisible = true
    },
    onProjectChange(val) {
      if (!val) this.$set(this.caseForm, 'showConstruction', 0)
    },
    openCategory(row) {
      this.categoryForm = row ? { ...row } : { name: '', sortNo: 0, status: 'ON' }
      this.categoryVisible = true
    },
    openGroup(row) {
      this.groupForm = row ? { ...row } : { name: '', sortNo: 0, status: 'ON' }
      this.groupVisible = true
    },
    openTag(row) {
      this.tagForm = row
        ? { ...row }
        : { groupId: this.currentGroupId || (this.groups[0] && this.groups[0].id) || null, name: '', sortNo: 0, status: 'ON' }
      this.tagVisible = true
    },
    onCaseCover(res) {
      const data = (res && res.data) || {}
      if (data.url) this.$set(this.caseForm, 'coverUrl', data.url)
    },
    async saveCase() {
      if (!this.caseForm.title) return this.$message.warning('请填写标题')
      this.saving = true
      try {
        const payload = {
          ...this.caseForm,
          tagIds: this.collectTagIds(),
          showConstruction: this.caseForm.projectId ? (this.caseForm.showConstruction ? 1 : 0) : 0
        }
        delete payload.tagPick
        await saveCmsCase(payload)
        this.$message.success('已保存')
        this.caseVisible = false
        this.loadCases()
      } finally {
        this.saving = false
      }
    },
    removeCase(row) {
      this.$confirm(`确认删除案例「${row.title}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteCmsCase(row.id)
          this.$message.success('已删除')
          this.loadCases()
        })
        .catch(() => {})
    },
    async saveCategory() {
      if (!this.categoryForm.name) return this.$message.warning('请填写名称')
      this.saving = true
      try {
        await saveCaseCategory(this.categoryForm)
        this.$message.success('已保存')
        this.categoryVisible = false
        this.loadCategories()
      } finally {
        this.saving = false
      }
    },
    async saveGroup() {
      if (!this.groupForm.name) return this.$message.warning('请填写名称')
      this.saving = true
      try {
        await saveTagGroup(this.groupForm)
        this.$message.success('已保存')
        this.groupVisible = false
        this.loadGroups()
      } finally {
        this.saving = false
      }
    },
    removeGroup(row) {
      this.$confirm(`确认删除标签组「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteTagGroup(row.id)
          this.$message.success('已删除')
          if (this.currentGroupId === row.id) {
            this.currentGroupId = null
            this.refreshTags()
          }
          this.loadGroups()
        })
        .catch(() => {})
    },
    async saveTagRow() {
      if (!this.tagForm.name || !this.tagForm.groupId) return this.$message.warning('请填写标签组和名称')
      this.saving = true
      try {
        await saveTag(this.tagForm)
        this.$message.success('已保存')
        this.tagVisible = false
        this.loadAllTags()
      } finally {
        this.saving = false
      }
    },
    removeTag(row) {
      this.$confirm(`确认删除标签值「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteTag(row.id)
          this.$message.success('已删除')
          this.loadAllTags()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; align-items: center; }
.thumb { width: 56px; height: 40px; object-fit: cover; border-radius: 4px; }
.hint { margin-left: 8px; color: #94a3b8; font-size: 12px; }
.cover-preview {
  margin-top: 10px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
}
.cover-preview img {
  width: 160px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}
</style>
